module.exports = __webpack_public_path__ + "assets/img/honor4.ba3cc35d.png";